/// Type de feedback utilisateur (widget bug / avis / suggestion)
export enum FeedbackType {
  BUG = 'BUG',
  AVIS = 'AVIS',
  SUGGESTION = 'SUGGESTION',
}

/// Application émettrice du feedback
export enum FeedbackSource {
  ACADEMY = 'ACADEMY',
  PROMPTS = 'PROMPTS',
  HUB = 'HUB',
  FORGE = 'FORGE',
}

/// Statut de traitement d'un feedback (back-office)
export enum FeedbackStatus {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  RESOLVED = 'RESOLVED',
  ARCHIVED = 'ARCHIVED',
}
